import _ from 'lodash';
import globalUtils from '../utils/global.util';

export class ProductModel {
    constructor(data) {
        if (!data) data = {};
        this.cp_id = data.cp_id || 0;
        this.cp_name = data.cp_name || '';
        this.cp_imageid = data.cp_imageid || '';
        this.cp_unitprice = data.cp_unitprice || 0;
        this.cp_seocode = data.cp_seocode || '';

        this.quantity = data.quantity || 0;
        this.total = this.getTotal();

        this.cp_unitpriceStr = globalUtils.formatNumberToPrice(
            this.cp_unitprice
        );
        this.totalStr = globalUtils.formatNumberToPrice(this.total);
    }

    getTotal() {
        if (this.cp_unitprice === 0 || this.quantity === 0) return 0;
        return this.cp_unitprice * this.quantity;
    }
}
